import {useNavigate, useSearchParams} from "react-router-dom";
import {Col, message, Row} from "antd";
import {useEffect, useState} from "react";
import Api from "../common/Api";
import SignUpForm from "../components/SignUpForm";
import {useAuth} from "../context/Auth";
import {AxiosError} from "axios";

const SignUp = () => {
    const navigate = useNavigate();
    const {user} = useAuth();
    const [searchParams] = useSearchParams();
    const [group, setGroup] = useState<string>("");
    const [spinning, setSpinning] = useState(true);

    useEffect(() => {
        if (user)
            return navigate('/', {replace: true})
        if (!searchParams.get('sig') || !searchParams.get('group')) {
            return navigate("/forbidden", {replace: true});
        }
        (async () => {
            const {data} = await Api.management.verifyToken(searchParams.get('sig')!)
            if (!data.Item)
                return navigate("/forbidden", {replace: true});
            if (data.Item.group.S !== searchParams.get('group'))
                return navigate("/forbidden", {replace: true});
            setGroup(searchParams.get('group')!)
        })();
        setSpinning(false);
    }, [searchParams, navigate, user]);

    const onFinish = async (values: any) => {
        setSpinning(true);
        try {
            const {data: captcha} = await Api.management.verifyCaptcha(values.captcha);
            if (!captcha.success)
                return message.error('Invalid captcha')
            const {data} = await Api.management.signUp({
                email: values.email,
                password: values.password,
                name: `${values.firstName} ${values.lastName}`,
                manufacturer: values.manufacturer
            })
            message.success(data)
            navigate("/sign-in", {replace: true});
        } catch (e) {
            if (e instanceof AxiosError) {
                const error = e as AxiosError;
                return message.error(error.response?.data as string);
            }
            message.error('Unknown error')
        } finally {
            setSpinning(false)
        }
    };

    const onFinishFailed = async (errorInfo: any) => {

        console.log('Failed:', errorInfo);
    };


    return (
        <Row align="middle">
            <Col span={24} xs={{span: 22, offset: 1}}>
                <SignUpForm group={group} spinning={spinning} onFinish={onFinish} onFinishFailed={onFinishFailed}/>
            </Col>
        </Row>
    )
}

export default SignUp;
